import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useData } from "../../../components/firebase/DataProvider";
import {
  firefunctions,
  firestore,
} from "../../../components/firebase/FirebaseProvider";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import LevelSvg from "../../../assets/icon/level";
import CheckinSvg from "../../../assets/icon/checkin.svg";
import RewardPointSvg from "../../../assets/icon/rewardPoint";
import TokoramePointSvg from "../../../assets/icon/tokoramePoint";
import useStyles from "./style/tokoramPointStyle";
import DialogCheckIn from "../TokoramePoint/dialogCheckIn";
import Brightness1Icon from "@material-ui/icons/Brightness1";
import { useMemo } from "react";

function TokoramePoint() {
  const classes = useStyles();
  const history = useHistory();
  const { inpoinActivity, point, kredit } = useData();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coin, setCoin] = useState(false);
  const [multiplier, setMultiplier] = useState(false);
  const dateNow = new Date();

  const getData = async () => {
    setLoading(true);
    try {
      const utilityCol = firestore?.collection("utility");
      const voucherData = await utilityCol?.doc("reward_point")?.get();
      setMultiplier(voucherData?.data()?.multiplier);
      const funcList = await firefunctions.httpsCallable("inpoin-myVoucher")();
      const inpoinProfile = await firefunctions.httpsCallable(
        "inpoin-profile"
      )();
      const claim = funcList?.data?.data?.filter((a) => a.Status == "Claim");
      setCoin(inpoinProfile?.data?.data?.profiles?.coin);
      setData(claim ?? []);
      setLoading(false);
    } catch (error) {
      if (error) {
        const loginInpoin = async () => {
          try {
            await firefunctions.httpsCallable("inpoin-login")();
          } catch (error) {
            console.log("-loginInpoin", error);
          }
        };
        loginInpoin();
      }
      console.log("-listVoucher", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getRewardPoin = useMemo(() => {
    const PointAll = point.reduce(function (prev, curr) {
      return prev + curr.nilai;
    }, 0);

    const PenukaranAll =
      (kredit?.total_penukaran_reward_approved ?? 0) +
      (kredit?.total_penukaran_reward_pending ?? 0);

    const MyPoints = PointAll - PenukaranAll;
    return MyPoints;
  }, []);

  return (
    <>
      <Paper elevation={1} className={classes.container}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={6}
            container
            direction="row"
            alignItems="center"
            onClick={() => history.push("/akun/rewardpoint")}
            className={classes.grid}
          >
            <Grid item lg={1} xs={3} className={classes.gridIcon}>
              <IconButton size="small">
                <RewardPointSvg />
              </IconButton>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="body2" className={classes.liquidPrimary}>
                {getRewardPoin} Reward Point{" "}
                {multiplier > 1 ? (
                  <div
                    style={{
                      backgroundColor: "#F54C87",
                      padding: "0px 3.5px",
                      borderRadius: 4,
                      marginLeft: 5,
                      height: 17.5,
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontWeight: "bold",
                        fontSize: 10,
                      }}
                    >
                      x{multiplier}
                    </span>
                  </div>
                ) : null}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className={classes.liquidSecondary}
              >
                klik untuk melihat reward
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="row"
            alignItems="center"
            onClick={() => history.push("/tokoramecoin/voucher-history")}
            className={classes.grid}
          >
            <Grid item lg={1} xs={3} className={classes.gridIcon}>
              <IconButton size="small">
                <LevelSvg />
              </IconButton>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="body2" className={classes.liquidPrimary}>
                {data.length} Voucher
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className={classes.liquidSecondary}
              >
                klik untuk melihat voucher
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="row"
            alignItems="center"
            onClick={() => history.push("/tokoramecoin")}
            className={classes.grid}
          >
            <Grid item lg={1} xs={3} className={classes.gridIcon}>
              <IconButton size="small">
                <TokoramePointSvg />
              </IconButton>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="body2" className={classes.liquidPrimary}>
                {coin} Tokorame Coin
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className={classes.liquidSecondary}
              >
                lihat tokorame coin
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={6}
            container
            direction="row"
            alignItems="center"
            onClick={() => setOpen(true)}
            className={classes.grid}
          >
            <Grid item lg={1} xs={3} className={classes.gridIcon}>
              <IconButton size="small">
                {/* <Badge
                  color="secondary"
                  variant={
                    inpoinActivity?.checkin?.[dateNow.getDay()]
                      ? "standard"
                      : "dot"
                  }
                > */}
                <img alt="icon" src={CheckinSvg} style={{ width: 23 }} />
                {/* </Badge> */}
              </IconButton>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="body2" className={classes.liquidPrimary}>
                Daily Check In{" "}
                {!inpoinActivity?.checkin?.[dateNow.getDay()] ? (
                  <Brightness1Icon
                    color="secondary"
                    style={{ fontSize: 10, alignSelf: "center", marginLeft: 5 }}
                  />
                ) : null}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                className={classes.liquidSecondary}
              >
                {inpoinActivity?.checkin?.[dateNow.getDay()]
                  ? "5 coin telah dikirim"
                  : "klik untuk check-in"}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <DialogCheckIn open={open} handleClose={() => setOpen(false)} />
    </>
  );
}

export default TokoramePoint;
